/* HH.bedTurntable :: borderless corduroy-bed colour cycler. Ten transparent
   720x720 cutouts (assets/hh-bedclean-<slug>.webp) are stacked in the markup;
   this engine shows one at a time, auto-cycles through all ten with a soft
   crossfade, and lets the swatch row pick a colourway (which stops the
   auto-cycle on first interaction). The spin itself is pure CSS on
   .hh-hero__bed-spin (gated here on the autospin flag). Per-colourway hero
   background + bloom re-theme via data-bg-* and the colourways JSON. Reduced
   motion: no spin, no auto-cycle, static crimson cutout as poster. */
(function (w, d) {
  if (w.__hhBedTurntable) return;
  w.__hhBedTurntable = true;
  var HH = (w.HH = w.HH || {});

  var reduceMQ = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)');
  function prefersReduce() { return !!(reduceMQ && reduceMQ.matches); }

  function init(bed) {
    if (!bed || bed.__hhTtInit) return;
    bed.__hhTtInit = true;
    var ds = bed.dataset;

    // Canonical order; mirrors assets/hh-colorways.json.
    var order = 'crimson,cocoa,slate,butter,sand,rose,ivory,onyx,mintgreen,lilac'.split(',');
    var baseKey = ds.colorway || order[0];

    var section = (bed.closest && bed.closest('[data-hh-hero]')) || bed;
    var spin = bed.querySelector('[data-hh-bed-spin]');
    var swatches = [].slice.call(section.querySelectorAll('[data-hh-swatch]'));
    // The ten layered cutouts, keyed by colourway slug. Apply a small inline
    // layout + opacity floor so exactly one colourway shows correctly even if
    // the section stylesheet does not bundle on this store (a documented quirk;
    // the canonical CSS lives in styles-home.css). Inline opacity also drives
    // the crossfade, winning over any stale rule.
    var cuts = {};
    [].slice.call(bed.querySelectorAll('[data-hh-bed-cut]')).forEach(function (img) {
      cuts[img.getAttribute('data-hh-bed-cut')] = img;
      img.style.position = 'absolute';
      img.style.top = '0';
      img.style.left = '0';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'contain';
      img.style.opacity = img.classList.contains('is-active') ? '1' : '0';
    });

    var autospin = ds.autospin === '1' && !prefersReduce();
    var autocycle = ds.autocycle === '1' && !prefersReduce();
    var cycleMs = parseInt(ds.cycleMs, 10) || 3500;

    var current = baseKey;
    var userTookOver = false;
    var inView = true;
    var timer = 0;

    // Continuous CSS turntable spin only when the autospin flag is on and motion
    // is allowed. The keyframes live in the section stylesheet; we just gate the
    // class so the merchant toggle is honoured.
    if (spin && !autospin) spin.style.animation = 'none';

    // Per-colourway hero bg from data-bg-<slug>; CSS crossfades --hero-cycle-bg.
    function themeBg(key) {
      var bg = bed.getAttribute('data-bg-' + key);
      if (bg) section.style.setProperty('--hero-cycle-bg', bg);
    }
    var colorways = null;
    function themeBloom(key) {
      if (!colorways) return;
      var c = colorways.colorways && colorways.colorways[key];
      if (c && c.bloom) {
        ['a', 'b', 'c'].forEach(function (n, i) { section.style.setProperty('--hero-bloom-' + n, c.bloom[i]); });
      }
    }
    function syncSwatch(key) {
      swatches.forEach(function (s) {
        var on = s.getAttribute('data-hh-swatch') === key;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    // Show one colourway's cutout; the others fade out via CSS opacity. The
    // active image carries the real alt text, so swapping aria-hidden keeps the
    // accessible name on whichever bed is visible.
    function showColorway(key) {
      if (order.indexOf(key) < 0) return;
      current = key;
      Object.keys(cuts).forEach(function (k) {
        var img = cuts[k];
        var on = k === key;
        img.classList.toggle('is-active', on);
        img.style.opacity = on ? '1' : '0';
        if (on) img.removeAttribute('aria-hidden');
        else img.setAttribute('aria-hidden', 'true');
      });
      themeBg(key);
      themeBloom(key);
      syncSwatch(key);
    }

    function nextKey() { return order[(order.indexOf(current) + 1) % order.length]; }

    function start() {
      if (timer || userTookOver || !autocycle || !inView) return;
      timer = w.setInterval(function () {
        if (userTookOver || !inView) return;
        showColorway(nextKey());
      }, cycleMs);
    }
    function stop() { if (timer) { w.clearInterval(timer); timer = 0; } }
    function takeOver() { userTookOver = true; stop(); }

    // Swatch picker: pick a colourway and stop the hands-free demo.
    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        takeOver();
        showColorway(s.getAttribute('data-hh-swatch'));
      });
    });

    // Pause the cycle (and lighten the CPU) when the hero scrolls out of view.
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (es) {
        inView = !!(es[0] && es[0].isIntersecting);
        if (inView) start(); else stop();
      }, { threshold: 0.12, rootMargin: '120px 0px' });
      io.observe(bed);
    }
    d.addEventListener('visibilitychange', function () { if (d.hidden) stop(); else start(); });

    // Bloom palettes (and a sanity check on order) from the colourways JSON.
    if (ds.colorways) {
      fetch(ds.colorways, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          colorways = j;
          if (j && j.order && j.order.length) order = j.order.slice();
          themeBloom(current);
        })
        .catch(function () {});
    }

    // Boot on the base colourway, then begin the hands-free demo if enabled.
    showColorway(current);
    start();

    HH._heroBedTurntable = { show: showColorway, stop: stop, start: start };
  }

  function boot() {
    var beds = d.querySelectorAll('[data-hh-bed]');
    for (var i = 0; i < beds.length; i++) init(beds[i]);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})(window, document);
